import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";

// The backend keys users by email, so that is what the rest of the app calls "username".
// Depending on how the account was created Cognito exposes it either as the ID token
// email claim or as the username, so both are tried before giving up.
export async function GetSignedInUsername(): Promise<string | undefined> {
	const session = await fetchAuthSession()
	if (!session?.tokens?.accessToken) {
		return undefined
	}
	const emailClaim = session.tokens.idToken?.payload?.email
	if (typeof emailClaim === 'string' && emailClaim.length > 0) {
		return emailClaim
	}
	try {
		const currentUser = await getCurrentUser()
		return currentUser?.username
	} catch (error) {
		console.error('Could not read the current Cognito user:', error)
		return undefined
	}
}
